import "@quasar/extras/material-icons/material-icons.css"
import "quasar/src/css/index.sass"

import { Notify, Dialog, Loading } from "quasar"

export default {
  config: {},
  plugins: {
    Notify,
    Dialog,
    Loading
  }
}
